import type { AppServices } from '../app';
import type { Selection } from '../state';

// Lasting keys for things in the sky, so "Seen it" survives new data: Hipparcos numbers for stars,
// catalogue names for deep-sky objects, satellite numbers. What has been seen is kept night by night
// (live/nights.ts).

/** A lasting key for something in the sky, or null for things that cannot be ticked as seen. */
export function logKey(s: AppServices, sel: Selection): string | null {
  const e = s.engine;
  switch (sel.kind) {
    case 'body': return `body:${sel.id}`;
    case 'star': {
      const hip = e.stars.hip[sel.index];
      return hip ? `star:${hip}` : null;
    }
    case 'dso': return `dso:${e.dsos[sel.index].id}`;
    case 'constellation': return `con:${e.cons.constellations[sel.index].id}`;
    case 'satellite': return `sat:${sel.id}`;
    case 'shower': return `shower:${sel.code}`;
    case 'small': return `small:${sel.name}`;
    default: return null;
  }
}

export const PLANETS = ['Mercury', 'Venus', 'Mars', 'Jupiter', 'Saturn', 'Uranus', 'Neptune'];
